import { type MessageInstance } from "antd/es/message/interface";

import { privateAPI } from "../../../_config/constants";
import { errorHandler } from "../../_utils";
import { store, type TagFormType } from "..";
import { setTagLoading, setTags } from "../slices/tagSlice";

export const getTags = async (notify: MessageInstance) => {
  try {
    store.dispatch(setTagLoading(true));
    const response = await privateAPI.get("/onboarding/tags");
    if (response) {
      store.dispatch(setTagLoading(false));
      store.dispatch(setTags(response.data));
    }
    return response;
  } catch (error) {
    store.dispatch(setTagLoading(false));
    console.error("Get Tag Error:", error);
    errorHandler(error, notify);
  }
};

export const createTag = async (
  notify: MessageInstance,
  payload: TagFormType,
) => {
  try {
    store.dispatch(setTagLoading(true));
    const { data } = await privateAPI.post("/onboarding/tags", payload);
    notify.success("Tag created successfully!");
    return data;
  } catch (error) {
    console.error("Create Tag Error:", error);
    errorHandler(error, notify);
  } finally {
    store.dispatch(setTagLoading(false));
  }
};

export const updateTag = async (
  notify: MessageInstance,
  payload: TagFormType,
) => {
  try {
    if (!payload.id) return;
    store.dispatch(setTagLoading(true));
    const { data } = await privateAPI.put(
      `/onboarding/tags/${payload.id}`,
      payload,
    );
    notify.success("Tag updated successfully!");
    return data;
  } catch (error) {
    console.error("Update Tag Error:", error);
    errorHandler(error, notify);
  } finally {
    store.dispatch(setTagLoading(false));
  }
};

export const deleteTag = async (
  notify: MessageInstance,
  id: string,
  getData = false,
) => {
  try {
    store.dispatch(setTagLoading(true));
    const response = await privateAPI.delete(`/onboarding/tags/${id}`);
    if (response) {
      getData && (await getTags(notify));
    }
    notify.success("Tag deleted successfully!");
    return response;
  } catch (error) {
    console.error("Delete Tag Error:", error);
    errorHandler(error, notify);
  } finally {
    store.dispatch(setTagLoading(false));
  }
};
